/**
 * @generated SignedSource<<5f66d018d3cee2e8cf95d797b614c084>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CrawlCoverage = "FULL" | "PARTIAL" | "UNCHANGED" | "%future added value";
export type CrawlDisposition = "ACCESS_BLOCKED" | "CRAWLED" | "FAILED" | "ROBOTS_DISALLOWED" | "SKIPPED_NOT_CRAWLABLE" | "%future added value";
export type CrawlRunScope = "ALL_SITES" | "SINGLE_SITE" | "%future added value";
export type CrawlRunStatus = "COMPLETED" | "COMPLETED_WITH_ERRORS" | "FAILED" | "QUEUED" | "RUNNING" | "%future added value";
export type CrawlTrigger = "MANUAL" | "NIGHTLY" | "%future added value";
export type crawlRunQuery$variables = {
  id: any;
};
export type crawlRunQuery$data = {
  readonly crawlRun: {
    readonly run: {
      readonly completedUtc: any | null | undefined;
      readonly id: any;
      readonly listingsAdded: number;
      readonly listingsDelisted: number;
      readonly listingsMissed: number;
      readonly listingsUnchanged: number;
      readonly listingsUpdated: number;
      readonly rejectsQueued: number;
      readonly requestedByOperator: string;
      readonly requestedUtc: any;
      readonly scope: CrawlRunScope;
      readonly siteId: any | null | undefined;
      readonly sitesCrawled: number;
      readonly sitesPartiallyCrawled: number;
      readonly startedUtc: any | null | undefined;
      readonly status: CrawlRunStatus;
      readonly trigger: CrawlTrigger;
    };
    readonly sites: ReadonlyArray<{
      readonly completedUtc: any;
      readonly coverage: CrawlCoverage;
      readonly coverageNote: string | null | undefined;
      readonly disposition: CrawlDisposition;
      readonly error: string | null | undefined;
      readonly listingsAdded: number;
      readonly listingsDelisted: number;
      readonly listingsMissed: number;
      readonly listingsUnchanged: number;
      readonly listingsUpdated: number;
      readonly rejectsQueued: number;
      readonly siteId: any;
      readonly siteName: string;
      readonly startedUtc: any;
      readonly urlsInSitemap: number;
    }>;
  } | null | undefined;
};
export type crawlRunQuery = {
  response: crawlRunQuery$data;
  variables: crawlRunQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "siteId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedUtc",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedUtc",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "listingsAdded",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "listingsUpdated",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "listingsUnchanged",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "listingsMissed",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "listingsDelisted",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rejectsQueued",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CrawlRunDetail",
    "kind": "LinkedField",
    "name": "crawlRun",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CrawlRunSummary",
        "kind": "LinkedField",
        "name": "run",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "trigger",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requestedByOperator",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scope",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requestedUtc",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sitesCrawled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sitesPartiallyCrawled",
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CrawlSiteResultView",
        "kind": "LinkedField",
        "name": "sites",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "siteName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "disposition",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "coverage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "coverageNote",
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "urlsInSitemap",
            "storageKey": null
          },
          (v9/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "error",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "crawlRunQuery",
    "selections": (v10/*: any*/),
    "type": "AdminQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "crawlRunQuery",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "c2f89a2aa730cedaa4375379d964b253",
    "id": null,
    "metadata": {},
    "name": "crawlRunQuery",
    "operationKind": "query",
    "text": "query crawlRunQuery(\n  $id: UUID!\n) {\n  crawlRun(id: $id) {\n    run {\n      id\n      trigger\n      requestedByOperator\n      scope\n      siteId\n      status\n      requestedUtc\n      startedUtc\n      completedUtc\n      sitesCrawled\n      sitesPartiallyCrawled\n      listingsAdded\n      listingsUpdated\n      listingsUnchanged\n      listingsMissed\n      listingsDelisted\n      rejectsQueued\n    }\n    sites {\n      siteId\n      siteName\n      disposition\n      coverage\n      coverageNote\n      listingsAdded\n      listingsUpdated\n      listingsUnchanged\n      urlsInSitemap\n      rejectsQueued\n      listingsMissed\n      listingsDelisted\n      error\n      startedUtc\n      completedUtc\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8b1f5b2b443f905937be2ae241cf8f7f";

export default node;
